import TextSlideShow from './text-slide-show';

export default TextSlideShow;